/**
 * ## Accordion component
 *
 * @module src/components/accordion
 */

"use strict";

const conf = require("../../config");
const size = require("../size");
const tableslib = require("../chart/tables");
const func = require("../../controllers/func");
const chart = require("../../components/chart");
const l = require("../../common").localization;

/** Accordion
 */
const create = (options, data, callback) => {
  let thisHTML = '<div id="accordion_shell">';
  let c = 0;
  let progressBar;
  let section;
  let sectionBar = "";
  let partyHeader = "";
  let statuses = "";
  switch (options.mode) {
    case "context_table": {
      /*
        thisHTML += conf.vars.sections[data.activity.section].color;
        thisHTML += data.activity.table;
        thisHTML += data.activity.size;
        thisHTML += parseInt((Date.now() - data.activity.time) / 1000 / 60, 10);
        */

      thisHTML += '<div class="context_table_info">';
      if (data.activity !== undefined) {
        const seated = parseInt(
          (Date.now() / 1000 - data.activity.statusTimes.seated) / 60,
          10
        );
        let sizeIndex = Math.ceil(parseInt(data.activity.size, 10) / 2) - 1;
        if (sizeIndex > 6) {
          sizeIndex = 6;
        } else if (sizeIndex < 0) {
          sizeIndex = 0;
        }
        const turnTime =
          data.location.baseTurn * 60 +
          data.location.turnTimes[sizeIndex].turnTime * 60;
        const percentStatus3 =
          Math.floor(Date.now() / 1000) - data.activity.statusTimes.seated;
        let pwidth = Math.round((percentStatus3 / turnTime) * 100);
        partyHeader = l.translate("Server Assignment");
        section = data.activity.section;
        if (pwidth > 100) {
          pwidth = 100;
        }
        if (pwidth > 90) {
          progressBar = `width:${pwidth}%; background-color:#00ff00`;
        } else {
          progressBar = `width:${pwidth}%`;
        }
        data.location.tableStatus.forEach((tableStatus) => {
          let statusSelect = "";
          let styleSelect = "";
          if (tableStatus.value === data.activity.tableStatus) {
            statusSelect =
              '<i class="fa fa-chevron-right" aria-hidden="true"></i> ';
            styleSelect = "background-color:#666;";
          }
          let style = "";
          if (
            data.kd.location.tableStatus[c] &&
            data.kd.location.tableStatus[c].color
          ) {
            style = `border: 2px solid ${data.kd.location.tableStatus[c].color};`;
          }
          statuses += `<div id="context_table_status_btn${c}" \
                    class="btn4 context_table_status_btn" \
                    style="${style}${styleSelect}" \
                    data-value="${tableStatus.value}"> \
                    ${statusSelect}${tableStatus.description} \
                    </div>`;
          ++c;
        });

        let displayName = "";
        if (data.activity.name) {
          displayName = data.activity.name;
        }

        thisHTML += `<div id="context_table_label_size" class="theme_bg_carbon"> \
                            ${data.activity.size}</div> \
                            <div id="context_table_label_name">${displayName}</div> \
                            <div id="context_table_label_time">${seated} min</div> \
                            <div class="clear"></div>`;
      } else {
        partyHeader = l.translate("Table Party Size");
        if (data.disabled === 0) {
          statuses += `<div id="context_table_status_btn0" \
class="btn4 context_table_status_btn" data-value="1">${l.translate(
            "Disable"
          )}</div>`;
        } else {
          statuses += `<div id="context_table_status_btn0" \
class="btn4 context_table_status_btn" data-value="0">${l.translate(
            "Enable"
          )}</div>`;
        }

        // get table section from
        data.kd.templatedata.tables.forEach((table) => {
          if (table.table === data.table) {
            section = table.section;
            return;
          }
        });
      }
      if (section) {
        sectionBar = `color:${func.getColorByBg(
          conf.vars.sections[section].color
        )}; \
                background-color: ${conf.vars.sections[section].color}; `;
        if (conf.vars.sections[section].hasOwnProperty("color2")) {
          sectionBar += `border-left: 3px solid ${conf.vars.sections[section].color2}; `;
          sectionBar += `border-right: 3px solid ${conf.vars.sections[section].color2}; `;
        }
      }
      thisHTML += `<div id="context_table_label_table" style="${sectionBar}">${data.table}</div>`;
      if (data.activity !== undefined) {
        thisHTML += `<div id="context_table_label_progress_bg">\
                            <div id="context_table_label_progress_bar" style="${progressBar}"> \
                            </div></div>`;
      }
      thisHTML += '    <div class="clear"></div>';
      thisHTML += "</div>";
      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_table_header1" class="context_table_header" \
                        data-block="1">${l.translate("Table Status")}</div>`;
      thisHTML +=
        '<div id="context_table_body1" class="context_table_body" data-block="1">';
      thisHTML += statuses;
      thisHTML += "</div>";
      if (data.disabled === 0) {
        thisHTML += `<div id="context_table_header2" class="context_table_header" \
                            data-block="2">${partyHeader}</div>`;
        if (data.activity !== undefined) {
          thisHTML +=
            '<div id="context_table_body2" class="context_table_body" ' +
            'data-block="2">';
          // get unique sections from active template
          const uniqueSections = [];
          let d = 0;

          data.kd.templatedata.tables.forEach((table) => {
            if (!uniqueSections.includes(table.section)) {
              uniqueSections.push(table.section);
            }
          });

          uniqueSections.sort();

          uniqueSections.forEach((thissection) => {
            let checkMark = "";
            if (thissection === section) {
              checkMark = '<i class="fa fa-check"></i> ';
            }
            let btnStyle = `border-top-color:${conf.vars.sections[thissection].color}; `;
            if (conf.vars.sections[thissection].hasOwnProperty("color2")) {
              btnStyle += `border-left: 5px solid \
                                        ${conf.vars.sections[thissection].color2}; `;
              btnStyle += `border-right: 5px solid \
                                        ${conf.vars.sections[thissection].color2}; `;
            }
            let sectionDesc = thissection;
            data.location.assignments.forEach((assignment) => {
              if (assignment.section === thissection) {
                sectionDesc = assignment.server;
                return;
              }
            });

            thisHTML += `<div id="context_table_section_${d}" \
                                class="context_table_section_btn" data-value="${thissection}" \
                                style="${btnStyle}">${checkMark}${sectionDesc}</div>`;
            ++d;
          });
          thisHTML += "</div>";
          thisHTML += `<div id="context_table_header3" class="context_table_header" \
                    data-block="3">${l.translate("Options")}</div> \
                    <div id="context_table_body3" class="context_table_body" data-block="3"> \
                    <div id="context_waitlist_moveparty_btn1" class="btn4 \
                    context_waitlist_moveparty_btn" data-value="move"> \
                    ${l.translate("Move Party to New Table")}</div> \
                    <div id="context_waitlist_moveparty_btn2" \
                    class="btn4 context_waitlist_details_btn" data-value="details"> \
                    ${l.translate("Party Details")}</div> \
                    <div id="context_waitlist_moveparty_btn3" \
                    class="btn4 context_waitlist_backtoqueue_btn" data-value="backtoqueue"> \
                    ${l.translate("Move Back To Queue")}</div>`;
          if (
            data.location.hasOwnProperty("chitSeat") &&
            data.location.chitSeat
          ) {
            thisHTML += `<div id="context_waitlist_printchit_btn" \
                    class="btn4 context_waitlist_printchit_btn" data-value="printchit"> \
                    ${l.translate("Print Chit")}</div> \
                    </div>`;
          }
        } else {
          thisHTML +=
            '<div id="context_table_body2" class="context_table_body" ' +
            'data-block="2"></div>';
        }
      }
      thisHTML += "</div>";

      $(`#${options.target_id}`).html(thisHTML);

      if (data.activity !== undefined || data.disabled === 1) {
        TweenMax.to("#context_table_body1", 0, { height: 340 });
      } else {
        TweenMax.to("#context_table_body2", 0, { height: 340 });
      }

      // create size component

      if (data.activity === undefined) {
        const opt = {
          target_id: "context_table_body2",
          entry: true,
          limit: 10,
        };

        size.create(opt, {}, (err, value) => {
          callback(null, {
            type: "party_size",
            value,
            table: data.table,
            seats: data.seats,
            section,
          });
        });
        $("#context_table_body2")
          .prepend(`<div class="context_table_label_direct">\
                                              ${l.translate(
                                                "Direct Seat Party of:"
                                              )}</div>`);
      }

      break;
    }
    case "embed_context_table": {
      /*
        thisHTML += conf.vars.sections[data.activity.section].color;
        thisHTML += data.activity.table;
        thisHTML += data.activity.size;
        thisHTML += parseInt((Date.now() - data.activity.time) / 1000 / 60, 10);
        */

      progressBar;
      section;
      sectionBar = "";
      partyHeader = "";
      statuses = "";

      thisHTML += '<div class="embed_context_table_info">';
      if (data.activity !== undefined) {
        // const time = parseInt((Date.now() - data.activity.time) / 1000 / 60, 10);
        let sizeIndex = Math.ceil(parseInt(data.activity.size, 10) / 2) - 1;
        if (sizeIndex > 6) {
          sizeIndex = 6;
        } else if (sizeIndex < 0) {
          sizeIndex = 0;
        }
        const turnTime =
          data.location.baseTurn * 60 * 1000 +
          data.location.turnTimes[sizeIndex].turnTime * 60 * 1000;
        const percentStatus3 = Date.now() - data.activity.time;
        let pwidth = Math.round((percentStatus3 / turnTime) * 100);
        partyHeader = l.translate("Server Assignment");
        section = data.activity.section;
        if (pwidth > 100) {
          pwidth = 100;
        }
        if (pwidth > 90) {
          progressBar = `width:${pwidth}%; background-color:#00ff00`;
        } else {
          progressBar = `width:${pwidth}%`;
        }

        let displayName = "";
        if (data.activity.name) {
          displayName = data.activity.name;
        }

        thisHTML += `<div id="context_table_label_size" \
                        class="theme_bg_carbon">${data.activity.size}</div>`;
        thisHTML += `<div id="context_table_label_name">${displayName}</div>`;
        // thisHTML += `<div id="context_table_label_time">${time} min</div>`;
        thisHTML += '<div class="clear"></div>';

        thisHTML += `<div id="embed_context_table_btn5" class="btn4 embed_context_table_btn" \
                        data-value="open_order">${l.translate(
                          "Open Order"
                        )}</div>`;
        thisHTML += `<div id="embed_context_table_btn6" class="btn4 embed_context_table_btn" \
                        data-value="new_segment">${l.translate(
                          "Add New Segment"
                        )}</div>`;
        thisHTML += `<div id="embed_context_table_btn7" class="btn4 embed_context_table_btn" \
                        data-value="pay_now" data-amount="${
                          data.activity.total
                        }"> \
                        ${l.translate("Pay Now")} (${l.translate("$")}${
          data.activity.total
        })\
                        </div>`;

        thisHTML += '<div class="">';

        c = 0;
        data.location.tableStatus.forEach((tableStatus) => {
          let statusSelect = "";
          let styleSelect = "";
          if (tableStatus.value === data.activity.tableStatus) {
            statusSelect =
              '<i class="fa fa-chevron-right" aria-hidden="true"></i> ';
            styleSelect = "background-color:#666;";
          }
          let style = "";
          if (
            data.location.tableStatus[c] &&
            data.location.tableStatus[c].color
          ) {
            style = `border: 1px solid ${data.location.tableStatus[c].color};`;
          }
          statuses += `<div id="context_table_status_btn${c}" \
                            class="btn13 context_table_status_btn" style="${style}${styleSelect}" \
                            data-value="${tableStatus.value}">\
                            ${statusSelect}${tableStatus.description}</div>`;
          ++c;
        });

        /*
             * This adds statuses to the context menu of an occupied table.
            thisHTML += '<div class="embed_status_title">Table Status</div>';
            thisHTML += '<div class="embed_status_scroll">';
            thisHTML += statuses;
            thisHTML += '</div>';
            */
      } else {
        thisHTML += `<div id="embed_context_table_btn0" class="btn4 embed_context_table_btn" \
                        data-value="new_order">${l.translate(
                          "Start New Order"
                        )}</div>`;
        /*
            if (data.disabled === 0) {
                thisHTML += '<div id="embed_context_table_btn1a" ' +
                        'class="btn4 embed_context_table_btn" data-value="disable">Disable</div>';
            } else {
                thisHTML += '<div id="embed_context_table_btn2a" ' +
                        'class="btn4 embed_context_table_btn" data-value="enable">Enable</div>';
            }
            */

        // get table section from
        /*
            data.kd.templatedata.tables.forEach((table) => {
                if (table.table == data.table) {
                    section = table.section;
                    return;
                }
            });
            */
      }
      thisHTML += "</div>";

      $(`#${options.target_id}`).html(thisHTML);

      break;
    }
    case "embed_context_table_multiple": {
      /*
        thisHTML += conf.vars.sections[data.activity.section].color;
        thisHTML += data.activity.table;
        thisHTML += data.activity.size;
        thisHTML += parseInt((Date.now() - data.activity.time) / 1000 / 60, 10);
        */

      progressBar;
      section;
      sectionBar = "";
      partyHeader = "";
      statuses = "";

      thisHTML += '<div class="embed_context_table_info">';

      thisHTML += `<div id="context_table_label_size" \
                        class="theme_bg_carbon">${data.orders[0].table}</div>`;
      thisHTML += '<div id="context_table_label_name">Orders</div>';
      thisHTML += '<div class="clear"></div>';
      for (let i = 0; i < data.orders.length; ++i) {
        thisHTML += `<div id="embed_context_table_multiple_btn${i}" \
                class="btn4 embed_context_table_multiple_btn" \
                data-value="${i}">${getRoomName(
          data.kd,
          data.kd.localstore.data.room
        )} \
                ${data.orders[i].table}:${i + 1}</div>`;
      }

      thisHTML += "</div>";

      $(`#${options.target_id}`).html(thisHTML);

      break;
    }
    case "context_waitlist": {
      let notes = "";
      if (data.activity.customNotes) {
        notes += `${data.activity.customNotes}, `;
      }
      data.activity.notes.forEach((note) => {
        if (note.active) {
          notes += `${note.value}, `;
        }
      });
      thisHTML +=
        '<div id="context_waitlist_info" class="context_waitlist_info">';
      thisHTML += `<div id="context_waitlist_label_size">${data.activity.size}</div>`;
      thisHTML += `<div id="context_waitlist_label_name">${data.activity.name}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_waitlist_label_notes" class="context_notes">\
                    ${notes.substring(0, notes.length - 2)}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += "</div>";

      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_table_header1" class="context_table_header" \
                    data-block="1">${l.translate("Actions")}</div>`;
      thisHTML +=
        '<div id="context_table_body1" class="context_table_body" data-block="1">';
      let seatParty = l.translate("Seat Party");
      let seatDirective = "seatparty";
      if (conf.vars.ui === "waitlist") {
        seatParty = l.translate("Fulfill Party");
        seatDirective = "fulfill";
        // LEFT OFF HERE, 10/2/2018: 'fulfill' must be processed at waitlist, pre-cehck, and no shows
      }
      if (
        data.activity.hasOwnProperty("preSelect") &&
        data.activity.preSelect.length > 0
      ) {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn2" data-value="${seatDirective}">\
                    ${seatParty} (${data.activity.preSelect.join(", ")})</div>`;
      } else {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn1" data-value="${seatDirective}">\
                    ${seatParty}</div>`;
      }
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn3" data-value="sendalert">\
                    ${l.translate("Send Alert")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn5" data-value="details">\
                    ${l.translate("Party Details")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn7" data-value="precheckin">\
                    ${l.translate("Move to Pre-Check")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn6" data-value="noshows">\
                    ${l.translate("Move To No Shows")}</div>`;
      if (
        options.kd.location.hasOwnProperty("chitQueue") &&
        options.kd.location.chitQueue
      ) {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn8" data-value="printchit">\
                    ${l.translate("Print Chit")}</div>`;
      }
      if (
        data.activity.hasOwnProperty("res_id") &&
        data.activity.res_id.length > 0
      ) {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn9" data-value="moveback">\
                    ${l.translate("Move Back To Reservations")}</div>`;
      }
      thisHTML += "</div>";
      thisHTML += `<div id="context_table_header2" class="context_table_header" data-block="2">\
                    ${l.translate("Options")}</div>`;
      thisHTML +=
        '<div id="context_table_body2" class="context_table_body" data-block="2">';
      /*
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn6" data-value="partydetails">\
                    ${l.translate('Send Alert')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn7" data-value="unsave">\
                    ${l.translate('Unsave')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn8" data-value="save">\
                    ${l.translate('Save')}</div>`;
        */
      thisHTML += "</div>";

      $(`#${options.target_id}`).html(thisHTML);

      TweenMax.to("#context_table_body1", 0, { height: 340 });
      break;
    }
    case "context_noshows": {
      let notes = "";
      if (data.activity.customNotes) {
        notes += `${data.activity.customNotes}, `;
      }
      data.activity.notes.forEach((note) => {
        if (note.active) {
          notes += `${note.value}, `;
        }
      });
      thisHTML +=
        '<div id="context_waitlist_info" class="context_waitlist_info">';
      thisHTML += `<div id="context_waitlist_label_size">${data.activity.size}</div>`;
      thisHTML += `<div id="context_waitlist_label_name">${data.activity.name}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_waitlist_label_notes" class="context_notes">\
                    ${notes.substring(0, notes.length - 2)}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += "</div>";

      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_table_header1" class="context_table_header" \
                    data-block="1">${l.translate("Actions")}</div>`;
      thisHTML +=
        '<div id="context_table_body1" class="context_table_body" data-block="1">';
      if (
        data.activity.hasOwnProperty("preSelect") &&
        data.activity.preSelect.length > 0
      ) {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn2" data-value="seatparty">\
                    ${l.translate(
                      "Seat Party"
                    )} (${data.activity.preSelect.join(", ")})</div>`;
      } else {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn1" data-value="seatparty">\
                    ${l.translate("Seat Party")}</div>`;
      }
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn3" data-value="backtoqueue">\
                    ${l.translate("Send Back To Queue")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn5" data-value="details">\
                    ${l.translate("Party Details")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn7" data-value="precheckin">\
                    ${l.translate("Move to Pre-Check")}</div>`;
      if (
        data.activity.hasOwnProperty("res_id") &&
        data.activity.res_id.length > 0
      ) {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn9" data-value="moveback">\
                    ${l.translate("Move Back To Reservations")}</div>`;
      }
      thisHTML += "</div>";
      thisHTML += `<div id="context_table_header2" class="context_table_header" data-block="2">\
                    ${l.translate("Options")}</div>`;
      thisHTML +=
        '<div id="context_table_body2" class="context_table_body" data-block="2">';
      /*
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn6" data-value="partydetails">\
                    ${l.translate('Send Alert')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn7" data-value="unsave">\
                    ${l.translate('Unsave')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn8" data-value="save">\
                    ${l.translate('Save')}</div>`;
        */
      thisHTML += "</div>";

      $(`#${options.target_id}`).html(thisHTML);

      TweenMax.to("#context_table_body1", 0, { height: 340 });
      break;
    }
    case "context_resnoshows": {
      let notes = "";
      if (data.activity.customNotes) {
        notes += `${data.activity.customNotes}, `;
      }
      data.activity.notes.forEach((note) => {
        if (note.active) {
          notes += `${note.value}, `;
        }
      });
      thisHTML +=
        '<div id="context_waitlist_info" class="context_waitlist_info">';
      thisHTML += `<div id="context_waitlist_label_size">${data.activity.size}</div>`;
      thisHTML += `<div id="context_waitlist_label_name">${data.activity.name}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_waitlist_label_notes" class="context_notes">\
                    ${notes.substring(0, notes.length - 2)}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += "</div>";

      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_table_header1" class="context_table_header" \
                    data-block="1">${l.translate("Actions")}</div>`;
      thisHTML +=
        '<div id="context_table_body1" class="context_table_body" data-block="1">';
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn3" data-value="rescancel">\
                    ${l.translate("Cancel This Reservation")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn5" data-value="details">\
                    ${l.translate("Party Details")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn9" data-value="movetores">\
                    ${l.translate("Move Back To Reservations")}</div>`;
      thisHTML += "</div>";
      thisHTML += `<div id="context_table_header2" class="context_table_header" data-block="2">\
                    ${l.translate("Options")}</div>`;
      thisHTML +=
        '<div id="context_table_body2" class="context_table_body" data-block="2">';
      /*
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn6" data-value="partydetails">\
                    ${l.translate('Send Alert')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn7" data-value="unsave">\
                    ${l.translate('Unsave')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn8" data-value="save">\
                    ${l.translate('Save')}</div>`;
        */
      thisHTML += "</div>";

      $(`#${options.target_id}`).html(thisHTML);

      TweenMax.to("#context_table_body1", 0, { height: 340 });
      break;
    }
    case "context_precheck": {
      let notes = "";
      if (data.activity.customNotes) {
        notes += `${data.activity.customNotes}, `;
      }
      data.activity.notes.forEach((note) => {
        if (note.active) {
          notes += `${note.value}, `;
        }
      });
      thisHTML +=
        '<div id="context_waitlist_info" class="context_waitlist_info">';
      thisHTML += `<div id="context_waitlist_label_size">${data.activity.size}</div>`;
      thisHTML += `<div id="context_waitlist_label_name">${data.activity.name}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_waitlist_label_notes" class="context_notes">\
                    ${notes.substring(0, notes.length - 2)}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += "</div>";

      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_table_header1" class="context_table_header" \
                    data-block="1">${l.translate("Actions")}</div>`;
      thisHTML +=
        '<div id="context_table_body1" class="context_table_body" data-block="1">';
      if (
        data.activity.hasOwnProperty("preSelect") &&
        data.activity.preSelect.length > 0
      ) {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn2" data-value="seatparty">\
                    ${l.translate(
                      "Seat Party"
                    )} (${data.activity.preSelect.join(", ")})</div>`;
      } else {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn1" data-value="seatparty">\
                    ${l.translate("Seat Party")}</div>`;
      }
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn3" data-value="backtoqueue">\
                    ${l.translate("Send Back To Queue")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn5" data-value="details">\
                    ${l.translate("Party Details")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn8" data-value="printchit">\
                    ${l.translate("Print Chit")}</div>`;
      if (
        data.activity.hasOwnProperty("res_id") &&
        data.activity.res_id.length > 0
      ) {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn9" data-value="moveback">\
                    ${l.translate("Move Back To Reservations")}</div>`;
      }
      thisHTML += "</div>";
      thisHTML += `<div id="context_table_header2" class="context_table_header" data-block="2">\
                    ${l.translate("Options")}</div>`;
      thisHTML +=
        '<div id="context_table_body2" class="context_table_body" data-block="2">';
      /*
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn6" data-value="partydetails">\
                    ${l.translate('Send Alert')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn7" data-value="unsave">\
                    ${l.translate('Unsave')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn8" data-value="save">\
                    ${l.translate('Save')}</div>`;
        */
      thisHTML += "</div>";

      $(`#${options.target_id}`).html(thisHTML);

      TweenMax.to("#context_table_body1", 0, { height: 340 });
      break;
    }
    case "context_seated": {
      let notes = "";
      if (data.activity.customNotes) {
        notes += `${data.activity.customNotes}, `;
      }
      data.activity.notes.forEach((note) => {
        if (note.active) {
          notes += `${note.value}, `;
        }
      });
      thisHTML +=
        '<div id="context_waitlist_info" class="context_waitlist_info">';
      thisHTML += `<div id="context_waitlist_label_size">${data.activity.size}</div>`;
      thisHTML += `<div id="context_waitlist_label_name">${data.activity.name}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_waitlist_label_notes" class="context_notes">\
                    ${notes.substring(0, notes.length - 2)}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += "</div>";

      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_table_header1" class="context_table_header" \
                    data-block="1">${l.translate("Actions")}</div>`;
      thisHTML +=
        '<div id="context_table_body1" class="context_table_body" data-block="1">';
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn3" data-value="backtoqueue">\
                    ${l.translate("Send Back To Queue")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn5" data-value="details">\
                    ${l.translate("Party Details")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn8" data-value="printchit">\
                    ${l.translate("Print Chit")}</div>`;
      thisHTML += "</div>";
      thisHTML += `<div id="context_table_header2" class="context_table_header" data-block="2">\
                    ${l.translate("Options")}</div>`;
      thisHTML +=
        '<div id="context_table_body2" class="context_table_body" data-block="2">';
      /*
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn6" data-value="partydetails">\
                    ${l.translate('Send Alert')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn7" data-value="unsave">\
                    ${l.translate('Unsave')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn8" data-value="save">\
                    ${l.translate('Save')}</div>`;
        */
      thisHTML += "</div>";

      $(`#${options.target_id}`).html(thisHTML);

      TweenMax.to("#context_table_body1", 0, { height: 340 });
      break;
    }
    case "context_reservation": {
      let notes = "";
      if (
        data.activity.hasOwnProperty("customNotes") &&
        data.activity.customNotes
      ) {
        notes += `${data.activity.customNotes}, `;
      }
      data.activity.notes.forEach((note) => {
        if (note.active) {
          notes += `${note.value}, `;
        }
      });
      thisHTML +=
        '<div id="context_waitlist_info" class="context_waitlist_info">';
      thisHTML += `<div id="context_waitlist_label_size">${data.activity.size}</div>`;
      thisHTML += `<div id="context_waitlist_label_name">${data.activity.name}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_waitlist_label_notes" class="context_notes">\
                    ${notes.substring(0, notes.length - 2)}</div>`;
      thisHTML += '<div class="clear"></div>';
      thisHTML += "</div>";

      thisHTML += '<div class="clear"></div>';
      thisHTML += `<div id="context_table_header1" class="context_table_header" \
                    data-block="1">${l.translate("Actions")}</div>`;
      thisHTML +=
        '<div id="context_table_body1" class="context_table_body" data-block="1">';

      let seatLabel = "Seat Party";
      let seatDirective = "seatparty";
      if (conf.vars.ui === "reservation") {
        seatLabel = "Fulfill Reservation";
        seatDirective = "fulfill";
      }
      if (
        data.activity.hasOwnProperty("preSelect") &&
        data.activity.preSelect.length > 0
      ) {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn2" data-value="${seatDirective}">\
                    ${l.translate(seatLabel)} (${data.activity.preSelect.join(
          ", "
        )})</div>`;
      } else {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn1" data-value="${seatDirective}">\
                    ${l.translate(seatLabel)}</div>`;
      }
      if (conf.vars.ui !== "reservation") {
        thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                        id="context_waitlist_moveparty_btn4" data-value="movetowaitlist">\
                        ${l.translate("Move to Waitlist")}</div>`;
      }
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn5" data-value="details">\
                    ${l.translate("Reservation Details")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn6" data-value="cancel">\
                    ${l.translate("Cancel Reservation")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn8" data-value="movetoresnoshows">\
                    ${l.translate("Move To Res No Shows")}</div>`;
      thisHTML += `<div class="btn4 context_waitlist_moveparty_btn" \
                    id="context_waitlist_moveparty_btn7" data-value="printchit">\
                    ${l.translate("Print Chit")}</div>`;
      thisHTML += "</div>";
      thisHTML += `<div id="context_table_header2" class="context_table_header" data-block="2">\
                    ${l.translate("Options")}</div>`;
      thisHTML +=
        '<div id="context_table_body2" class="context_table_body" data-block="2">';
      /*
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn6" data-value="partydetails">\
                    ${l.translate('Send Alert')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn7" data-value="unsave">\
                    ${l.translate('Unsave')}</div>`;
        thisHTML += `<div class="btn4 context_waitlist_options_btn" \
                    id="context_waitlist_options_btn8" data-value="save">\
                    ${l.translate('Save')}</div>`;
        */
      thisHTML += "</div>";

      $(`#${options.target_id}`).html(thisHTML);

      TweenMax.to("#context_table_body1", 0, { height: 340 });
      break;
    }
    case "table": {
      c = 0;
      thisHTML += '<div class="content_align" id="content_align_box">';
      thisHTML += `<div class="content_align">${l.translate(
        "Selection Alignment"
      )}:</div>`;
      thisHTML +=
        '<div class="content_align_icon" id="content_align_horizontal">' +
        '<i class="fas fa-align-center fa-2x"></i></div>';
      thisHTML +=
        '<div class="content_align_icon" id="content_align_vertical">' +
        '<i class="fas fa-align-center fa-2x fa-rotate-90"></i></div>';
      thisHTML += "</div>";
      thisHTML += '<div class="clear"></div>';
      Object.keys(options.tables).forEach((ky) => {
        ++c;
        thisHTML += `<div id="configuration_table_header${c}" \ 
                        class="configuration_table_header" data-block="${c}">\
                        ${l.translate(ky)}</div>`;
        thisHTML += `<div id="configuration_table_body${c}" \
                        class="configuration_table_body" data-block="${c}">`;
        options.tables[ky].seats.forEach((seat) => {
          thisHTML += `<div class="table_lib table_editor" id="editor_${ky}_${seat}" \
                            data-source="editor" data-type="${ky}" data-seat="${seat}">`;
          thisHTML += `<div class="table_editor_select" \
                            id="table_editor_select_${ky}_${seat}" data-type="${ky}" \
                            data-seat="${seat}">`;
          if (ky === "icon") {
            thisHTML += '<div class="top">';
          }
          thisHTML += tableslib.lib[`${ky}_${seat}`];
          if (ky === "icon") {
            thisHTML += "</div>";
          }
          thisHTML += "</div></div>";
        });
        // thisHTML += options.tables[ky].seats[0];
        thisHTML += "</div>";
        // + type + '</div>';
      });
      $(`#${options.target_id}`).html(thisHTML);
      TweenMax.to("#configuration_table_body1", 0, { height: 306 });

      break;
    }
    case "section": {
      c = 0;
      options.sections.forEach((eachsection) => {
        ++c;
        thisHTML += `<div id="configuration_section_header${c}" \
                        class="configuration_section_header" data-block="${c}">\
                        ${l.translate(eachsection.description)}</div>`;
        thisHTML += `<div id="configuration_section_body${c}" \
                        class="configuration_section_body" data-block="${c}">`;
        let i = 0;
        eachsection.data.forEach((color) => {
          if (i > 0 && i <= 24 && eachsection.description === "Basic") {
            thisHTML += `<div class="section_lib" style="color:\
                        ${func.getColorByBg(color.color)}; background-color:${
              color.color
            }" \
                                id="editor_section_basic_${i}" data-id="${i}" \
                                data-color="${color.color}">`;
            thisHTML += i;
            thisHTML += "</div>";
          }
          if (i > 24 && eachsection.description === "Combinations") {
            thisHTML += `<div class="section_lib" style="color:\
                        ${func.getColorByBg(color.color)}; background-color:${
              color.color
            }; \
                border-left: 6px solid ${
                  color.color2
                }; border-right: 6px solid ${color.color2};" \
                id="editor_section_combo_${i}" data-id="${i}" data-color="${
              color.color
            }">`;
            thisHTML += i;
            thisHTML += "</div>";
          }
          ++i;
        });
        // thisHTML += options.tables[ky].seats[0];
        thisHTML += "</div>";
        // + type + '</div>';
      });
      thisHTML += '<div class="clear"></div>';
      $(`#${options.target_id}`).html(thisHTML);
      TweenMax.to("#configuration_section_body1", 0, { height: 350 });

      break;
    }
    default: {
      break;
    }
  }

  $(".configuration_section_header").off();
  $(".configuration_section_header").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    TweenMax.to(".configuration_section_body", conf.vars.interfaceSpeed, {
      height: 0,
      ease: Power2.easeOut,
    });
    TweenMax.to(
      `#configuration_section_body${$(`#${e.target.id}`).data("block")}`,
      conf.vars.interfaceSpeed,
      {
        height: 350,
        ease: Power2.easeOut,
      }
    );
  });

  $(".configuration_table_header").off();
  $(".configuration_table_header").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    TweenMax.to(".configuration_table_body", conf.vars.interfaceSpeed, {
      height: 0,
      ease: Power2.easeOut,
    });
    TweenMax.to(
      `#configuration_table_body${$(`#${e.target.id}`).data("block")}`,
      conf.vars.interfaceSpeed,
      {
        height: 306,
        ease: Power2.easeOut,
      }
    );
  });

  $(".context_table_header").off();
  $(".context_table_header").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    TweenMax.to(".context_table_body", conf.vars.interfaceSpeed, {
      height: 0,
      ease: Power2.easeOut,
    });
    TweenMax.to(
      `#context_table_body${$(`#${e.target.id}`).data("block")}`,
      conf.vars.interfaceSpeed,
      {
        height: 340,
        ease: Power2.easeOut,
      }
    );
  });

  $(".context_table_status_btn").off();
  $(".context_table_status_btn").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    callback(null, {
      type: "table_status",
      description: $(`#${e.target.id}`).html(),
      value: parseInt($(`#${e.target.id}`).data("value"), 10),
      table: data.table,
      activity: data.activity,
    });
    destroy();
  });

  $(".section_lib").off();
  $(".section_lib").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    $(".section_lib").removeClass("section_lib_highlight");
    // $('#' + e.target.id).data('id');
    $(`#${e.target.id}`).addClass("section_lib_highlight");
    callback(null, {
      type: "editor_section",
      description: $(`#${e.target.id}`).data("color"),
      value: $(`#${e.target.id}`).data("id"),
    });
    destroy();
  });

  $(".context_table_section_btn").off();
  $(".context_table_section_btn").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    callback(null, {
      type: "table_section",
      description: $(`#${e.target.id}`).html(),
      value: $(`#${e.target.id}`).data("value"),
      table: data.table,
      activity: data.activity,
    });
    destroy();
  });

  $(".embed_context_table_btn").off();
  $(".embed_context_table_btn").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    callback(null, {
      type: "embed_table",
      description: $(`#${e.target.id}`).html(),
      value: $(`#${e.target.id}`).data("value"),
      table: data.table,
      activity: data.activity,
    });
    destroy();
  });

  $(".embed_context_table_mutliple_btn").off();
  $(".embed_context_table_multiple_btn").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    const index = $(`#${e.target.id}`).data("value");
    callback(null, {
      type: "embed_table_multiple",
      description: $(`#${e.target.id}`).html(),
      value: index,
      table: data.table,
      order: data.orders[index],
    });
    destroy();
  });

  $(".context_table_options_btn").off();
  $(".context_table_options_btn").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    callback(null, {
      type: "table_options",
      description: $(`#${e.target.id}`).html(),
      value: $(`#${e.target.id}`).data("value"),
      table: data.table,
      activity: data.activity,
    });
    destroy();
  });

  $(".context_waitlist_details_btn").off();
  $(".context_waitlist_details_btn").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    callback(null, {
      type: "waitlist_details",
      description: $(`#${e.target.id}`).html(),
      value: $(`#${e.target.id}`).data("value"),
      table: data.table,
      activity: data.activity,
    });
    destroy();
  });

  $(".context_waitlist_backtoqueue_btn").off();
  $(".context_waitlist_backtoqueue_btn").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    callback(null, {
      type: "waitlist_backtoqueue",
      description: $(`#${e.target.id}`).html(),
      value: $(`#${e.target.id}`).data("value"),
      table: data.table,
      activity: data.activity,
    });
    destroy();
  });

  $(".context_waitlist_moveparty_btn").off();
  $(".context_waitlist_moveparty_btn").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    callback(null, {
      type: "waitlist_moveparty",
      description: $(`#${e.target.id}`).html(),
      value: $(`#${e.target.id}`).data("value"),
      table: data.table,
      activity: data.activity,
    });
    destroy();
  });

  $(".context_waitlist_printchit_btn").off();
  $(".context_waitlist_printchit_btn").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    callback(null, {
      type: "waitlist_printchit",
      description: $(`#${e.target.id}`).html(),
      value: $(`#${e.target.id}`).data("value"),
      table: data.table,
      activity: data.activity,
    });
    destroy();
  });

  $(".context_waitlist_options_btn").off();
  $(".context_waitlist_options_btn").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
    callback(null, {
      type: "waitlist_options",
      description: $(`#${e.target.id}`).html(),
      value: $(`#${e.target.id}`).data("value"),
      table: data.table,
      activity: data.activity,
    });
    destroy();
  });

  $("#accordion_shell").off();
  $("#accordion_shell").fastClick((e) => {
    e.preventDefault();
    e.stopPropagation();
  });

  $("#content_align_horizontal").off();
  $("#content_align_horizontal").fastClick((e) => {
    const multiSelect = chart.getMultiSelect();
    if (multiSelect.active) {
      const location = Object.assign({}, data.kd.doc("location")[0]);
      const chartdata = data.kd.doc("chart", location.chart)[0].tables;
      align(data.kd, "horizontal", multiSelect, chartdata);
    }
  });

  $("#content_align_vertical").off();
  $("#content_align_vertical").fastClick((e) => {
    const multiSelect = chart.getMultiSelect();
    if (multiSelect.active) {
      const location = Object.assign({}, data.kd.doc("location")[0]);
      const chartdata = data.kd.doc("chart", location.chart)[0].tables;
      align(data.kd, "vertical", multiSelect, chartdata);
    }
  });
};

const align = (kd, direction, multiSelect, chartdata) => {
  let avg = 0;
  let count = 0;
  for (let i = 0; i < multiSelect.tables.length; ++i) {
    for (let a = 0; a < chartdata.length; ++a) {
      if (multiSelect.tables[i].id === chartdata[a].id) {
        ++count;
        switch (direction) {
          case "horizontal": {
            avg += chartdata[a].x;
            break;
          }
          case "vertical": {
            avg += chartdata[a].y;
            break;
          }
          default: {
            break;
          }
        }
        break;
      }
    }
  }
  avg = parseInt(avg / count, 10);
  for (let i = 0; i < multiSelect.tables.length; ++i) {
    for (let a = 0; a < chartdata.length; ++a) {
      if (multiSelect.tables[i].id === chartdata[a].id) {
        switch (direction) {
          case "horizontal": {
            chartdata[a].x = avg;
            break;
          }
          case "vertical": {
            chartdata[a].y = avg;
            break;
          }
          default: {
            break;
          }
        }
        break;
      }
    }
  }
  kd.emit("chart.update", {});
};

const getRoomName = (kd, room) => {
  const loc = kd.doc("location")[0];
  const cha = kd.doc("chart", loc.chart)[0];
  return cha.rooms[parseInt(room - 1, 10)].name;
};

const destroy = () => {
  $("#component_accordion").html("");
  $("#component_catch").css("display", "none");
};

module.exports = {
  create,
  destroy,
};



/** WEBPACK FOOTER **
 ** ./src/components/accordion/index.js
 **/